import React from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import { makeUrl } from "commons/utils/http";

import ProductBlocksForm from "components/form/ProductBlocksForm";
import ProductForm from "components/form/ProductForm";
import ProductMaterialForm from "components/form/ProductMaterialForm";
import RelatedProductsForm from "components/form/RelatedProductsForm";

import { SaveContextProvider } from "context/save";

import useProductApi from "hooks/api/private/useProductApi";
import { useProductId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Prodotto modificato con successo",
        errorMsg: "Errore nella modifica del prodotto",
    });

    const productId = useProductId();

    const { duplicateProduct } = useProductApi();

    const navigate = useNavigate();

    const onDuplicateClick = React.useCallback(() => {
        const [apiCall] = duplicateProduct({ id: productId }, null);

        apiCall.then((response) => {
            navigate(
                makeUrl("/gestione-prodotti/prodotti/:productId/modifica", {
                    productId: response.id,
                }),
            );
        });
    }, [duplicateProduct, productId, navigate]);

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem className={"col-xs-auto"}>
                    <Button variant={"outlined"} onClick={onDuplicateClick}>
                        Duplica
                    </Button>
                </GridItem>
                <GridItem className={"col-xs-auto"}>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaProdotto() {
    const productId = useProductId();

    return (
        <GridColumn className={"product-page"}>
            <SaveContextProvider>
                <GridItem>
                    <GridRow justifyContent={"space-between"} alignItems={"end"}>
                        <GridItem>
                            <GridRow>
                                <GridItem>
                                    <h1>Modifica Prodotto</h1>
                                </GridItem>
                            </GridRow>
                        </GridItem>

                        <GridItem>
                            <ButtonSave />
                        </GridItem>
                    </GridRow>
                </GridItem>

                <ProductForm productId={productId} />

                <RelatedProductsForm productId={productId} />

                <ProductMaterialForm productId={productId} />

                <ProductBlocksForm productId={productId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaProdotto;
